import { useState } from "react";
import { Box, ButtonBase, Menu, MenuItem } from "@mui/material";
import { PTIcon, PTTypography } from "../../components/ui";

const LabelRoute = ({ isMobile, handleClick, ...route }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  // Open dropdown
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close dropdown
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      key={route.key}
      sx={{
        ml: 2,
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
      }}
    >
      <PTTypography
        sx={{
          cursor:
            route.children?.length > 0 || route?.disabled
              ? "default"
              : "pointer",
          color: "#FFFFFF",
        }}
        variant="body3"
        onClick={() => {
          if (route.disabled) return;
          if (route?.dialog) {
            route?.setOpenLoginDialog(true);
          } else if (route?.path && !(route.children?.length > 0)) {
            handleClick(route);
          }
        }}
      >
        {route?.label}
      </PTTypography>

      {route?.children && (
        <ButtonBase
          sx={{ ml: 1, display: "flex", alignItems: "center" }}
          onClick={handleOpen}
        >
          <PTIcon
            icon={Boolean(anchorEl) ? "arrowUp" : "arrowDown"}
            color={"#FFFFFF"}
          />
        </ButtonBase>
      )}

      {/* Dropdown menu for child items */}
      {route?.children && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          {route.children.map((child, index) => (
            <MenuItem
              key={index}
              disabled={child.disabled}
              onClick={() => {
                if (child.disabled) return;
                handleClose();
                if (child.path) {
                  handleClick(child);
                }
              }}
            >
              <PTTypography
                sx={{ fontFamily: "Sora", fontSize: "16px", color: "#000000" }}
              >
                {child.label}
              </PTTypography>
            </MenuItem>
          ))}
        </Menu>
      )}
    </Box>
  );
};

export default LabelRoute;
